import { useContext } from "react";
import { Pagination as NewPagination } from "app/(new-pages)/components/Pagination";
import { usePathname, useSearchParams } from "next/navigation";

import { LoadingContext } from "app/components/providers/loadingProvider";

const PAGE_SIZE = 15;

const Pagination = ({ page, pageQueryKey = "page", totalPages }) => {
  const total = totalPages * PAGE_SIZE;
  const { push } = useContext(LoadingContext);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleChangePage = (page) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(pageQueryKey, "" + page);
    push(pathname + "?" + newSearchParams.toString());
    scrollTo(0, 0);
  };

  return (
    <>
      {totalPages > 1 ? (
        <NewPagination current={page} total={total} pageSize={15} onChange={handleChangePage} />
      ) : null}
    </>
  );
};

export default Pagination;
